import { getFlowSinkIds } from 'js/actions/rag';
import useEntities from 'new/state/entities/repository/useEntities';

export function useExternalTriggerConfig(flowNodeId: number) {
  const { data: flowNodesEntities } = useEntities('flowNodes');
  const { data: sourcesEntities } = useEntities('sources');
  const { data: sinksEntities } = useEntities('sinks');
  const flow = flowNodesEntities[flowNodeId];
  const source = sourcesEntities[flow?.data_source_id];
  const sinks = getFlowSinkIds(flow, flowNodesEntities).map((id) => sinksEntities[id]) || [];
  const { run_profile } = source || {};

  return {
    flow,
    source,
    sinks,
    runProfile: run_profile,
  };
}
